import axios from 'axios';
import { OctResponse } from '../../models/OctResponse';
import {
	IKhoVatTuItem,
	IVatTuItem,
	IWarehouseResponse,
	SearchVatTuParams
} from '../models/VatTuModels';
import { KEY_LOCALSTORAGE } from '../../auth/core/_consts';
import { localStorageItem } from '../../utils/LocalStorage';
import { APP_CONFIGURATION_KEYS } from '../../utils/Constant';

const BASE_URL = localStorageItem.get(KEY_LOCALSTORAGE.CONFIGURATION)?.[APP_CONFIGURATION_KEYS.WAREHOUSE_URL] || process.env.REACT_APP_WMS_API_URL;

const KHO_VAT_TU_TERM_ID = 151;

//---------------WAREHOUSE--------------------
export const getTreeKhoVatTu = async (): Promise<OctResponse<IKhoVatTuItem>> => {
	const { data } = await axios.get<OctResponse<IKhoVatTuItem>>(`${BASE_URL}/term-sets/tree`, {
		params: {
			termId: KHO_VAT_TU_TERM_ID,
		},
	});
	return data;
};

export const searchVatTu = async (params: SearchVatTuParams): Promise<IVatTuItem[]> => {
	const { data } = await axios.post<OctResponse<IWarehouseResponse<IVatTuItem[]>>>(
		`${BASE_URL}/item/search`,
		params
	);
	return data.data.content;
};

export const getDanhSachTuTruc = async (): Promise<OctResponse<IWarehouseResponse<any>>> => {
	const { data } = await axios.get<OctResponse<any>>(`${BASE_URL}/category/warehouses`, {
		params: {
			level: 2
		},
	});
	return data;
};

export const getDanhSachLoaiVatTu = async (): Promise<OctResponse<IWarehouseResponse<any>>> => {
	const { data } = await axios.get<OctResponse<any>>(`${BASE_URL}/category/terms`, {
		params: {
			termSetId: 220
		},
	});
	return data;
};